import { Editable } from "./editable.model";

/**
 * Contact communication representing an email, phone, web 
 * site or other type of communication.
 */
export class Communication extends Editable {
    /** Unique internal identity of the contact communication. */
    public id: number;

    /** Unique internal identity of the corporation associated with the contact communication. */
    public corporateId: number;

    /** Unique internal identity of the dealership associated with the contact communication. */
    public dealershipId: number;

    /** Unique internal identity of the lot associated with the contact communication. */
    public lotId: number;

    /** Unique internal identity of the contact associated with the contact communication. */
    public contactId: number;

    /** Unique internal identity of the department associated with the contact communication. */
    public departmentId: number;

    /** The primary type of communication (phone, email, etc...) */
    public type: string;

    /** The sub type of the communication main type. (i.e. cell, home for type phone) */
    public subtype: string;

    /** The current value (phone digits, email address, etc...) of the communication. */
    public value: string;

    /** Indicates whether or not the communication is a primary one for the contact. */
    public primary: boolean;
}